import { useContext, useEffect } from 'react';
import { getAxiosInstance, areInterceptorsConfigured, setInterceptorsConfigured } from './axiosInstance';
import useRefreshToken from './useRefreshToken';
import { authContext } from '../context/authProvider';

const useAxiosInterceptors = () => {
    const refresh = useRefreshToken();
    const { auth } = useContext(authContext);
    const axiosInstance = getAxiosInstance();
  
    useEffect(() => {
      if (areInterceptorsConfigured()) {
        return;
      }
  
      const requestIntercept = axiosInstance.interceptors.request.use(
        (config) => {
          const currentAuth = JSON.parse(localStorage.getItem('auth') || 'null') || auth;
          
          if (!config.headers.Authorization && currentAuth) {
            config.headers.Authorization = `Bearer ${currentAuth}`;
          }
  
          config.headers['X-App-Source'] = 'webapp-frontend';
          config.headers['X-App-Platform'] = 'web';
  
          const userString = localStorage.getItem('user');
          if (userString) {
            try {
              const userObject = JSON.parse(userString);
              if (userObject?._id) {
                config.headers['X-User-Id'] = userObject._id;
              }
            } catch (error) {
              console.warn('Erreur parsing user data:', error);
            }
          }
          
          const guestId = localStorage.getItem('guestId');
          if (guestId) {
            config.headers['X-Guest-Id'] = guestId;
          }
  
          return config;
        },
        (error) => Promise.reject(error)
      );
  
      const responseIntercept = axiosInstance.interceptors.response.use(
        (response) => response,
        async (error) => {
          window.dispatchEvent(new CustomEvent('AxiosError', { detail: { error } }));
  
          const prevRequest = error?.config;
          if (error?.response?.status === 403 && !prevRequest?.sent) {
            prevRequest.sent = true;
            try {
              const newAccessToken = await refresh();
              if (newAccessToken) {
                prevRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                return axiosInstance(prevRequest);
              }
            } catch (refreshError) {
              console.error('Erreur lors du refresh token:', refreshError);
              return Promise.reject(error);
            }
          }
  
          return Promise.reject(error);
        }
      );
  
      setInterceptorsConfigured(true);
  
      return () => {
        if (areInterceptorsConfigured()) {
          axiosInstance.interceptors.request.eject(requestIntercept);
          axiosInstance.interceptors.response.eject(responseIntercept);
          setInterceptorsConfigured(false);
        }
      };
    }, []);
    return axiosInstance;
  };
  

  export default useAxiosInterceptors;